export const thumb = (url, w = 480) => {
  if (!url || typeof url !== "string" || !url.includes("/api/files/") || url.includes("?")) return url;
  return `${url}?w=${w}`;
};
